module.exports = __webpack_public_path__ + "img/slovenia.9b2f2a9a.png";